var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6322 25.3342H10.6338C10.635 25.3342 10.6363 25.334 10.6375 25.334H28.166C28.5975 25.334 28.977 25.0477 29.0956 24.6328L32.9627 11.0976C33.0461 10.8058 32.9877 10.4921 32.8051 10.2499C32.6223 10.0077 32.3366 9.86523 32.0332 9.86523H8.40257L7.71146 6.75512C7.61302 6.31276 7.22076 5.99805 6.76758 5.99805H0.966797C0.432793 5.99805 0 6.43084 0 6.96484C0 7.49885 0.432793 7.93164 0.966797 7.93164H5.99213C6.11449 8.48277 9.29938 22.815 9.48267 23.6396C8.45519 24.0862 7.73438 25.1107 7.73438 26.3008C7.73438 27.9 9.03552 29.2012 10.6348 29.2012H28.166C28.7 29.2012 29.1328 28.7684 29.1328 28.2344C29.1328 27.7004 28.7 27.2676 28.166 27.2676H10.6348C10.1018 27.2676 9.66797 26.8338 9.66797 26.3008C9.66797 25.7685 10.1003 25.3355 10.6322 25.3342ZM30.7514 11.7988L27.4366 23.4004H11.4102L8.83209 11.7988H30.7514Z",
    fill: "#956D84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66797 32.1016C9.66797 33.7008 10.9691 35.002 12.5684 35.002C14.1676 35.002 15.4688 33.7008 15.4688 32.1016C15.4688 30.5023 14.1676 29.2012 12.5684 29.2012C10.9691 29.2012 9.66797 30.5023 9.66797 32.1016ZM12.5684 31.1348C13.1014 31.1348 13.5352 31.5686 13.5352 32.1016C13.5352 32.6346 13.1014 33.0684 12.5684 33.0684C12.0354 33.0684 11.6016 32.6346 11.6016 32.1016C11.6016 31.5686 12.0354 31.1348 12.5684 31.1348Z",
    fill: "#956D84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.332 32.1016C23.332 33.7008 24.6332 35.002 26.2324 35.002C27.8317 35.002 29.1328 33.7008 29.1328 32.1016C29.1328 30.5023 27.8317 29.2012 26.2324 29.2012C24.6332 29.2012 23.332 30.5023 23.332 32.1016ZM26.2324 31.1348C26.7654 31.1348 27.1992 31.5686 27.1992 32.1016C27.1992 32.6346 26.7654 33.0684 26.2324 33.0684C25.6994 33.0684 25.2656 32.6346 25.2656 32.1016C25.2656 31.5686 25.6994 31.1348 26.2324 31.1348Z",
    fill: "#956D84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 8,
    r: 8,
    fill: "#956D84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.808 10.12H29.92V6.96L30.04 6.416L29.656 6.888L28.944 7.376L28.504 6.776L30.328 5.304H30.912V10.12H32V11H28.808V10.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.5b4b759af1ef6963666e7efe2127c2ab.svg";
export { ForwardRef as ReactComponent };